/**
 * Returns a stock message based on variant data, according to the matrix
 * in https://docs.google.com/document/d/1zfHLFd6HWPwwKlm5JNO3itaLMHnl7TQHrstpOHj7PTs/edit?tab=t.0#heading=h.u42vgpg3aywc
 * @param {Object} param
 * @param {boolean} param.availableForSale
 * @param {number} param.quantityAvailable
 * @param {number} [param.lowStockThreshold=5]
 * @param {?boolean} param.dnr
 * @param {?boolean} param.cargoReady
 * @param {?string} param.backorderDate
 *
 * @param {Object} message
 * @param {*} message.inStock - Message for in stock case
 * @param {*} message.lowStock - Message for low stock case
 * @param {*} message.outOfStock - Message for out of stock case
 * @param {*} message.reserveNow - Message for Reserve Now case when no date is available
 * @param {*} message.reserveNowDate - Message for Reserve Now case when date is available
 * @param {*} message.notifyMe - Message for Notify Me case when no date is available
 * @param {*} message.notifyMeDate - Message for Notify Me case when date is available
 *
 * @returns {*} applicable stock message
 */
export default function stockMessage({
  availableForSale,
  quantityAvailable,
  lowStockThreshold,
  dnr,
  cargoReady,
  backorderDate,
  messages,
}) {
  const adjustedLowStockThreshold = lowStockThreshold || 5;

  // 0 available, do not continue selling
  if (!availableForSale) {
    return messages.outOfStock;
  }

  // 1+ available
  if (quantityAvailable > 0) {
    if (quantityAvailable <= adjustedLowStockThreshold) {
      return messages.lowStock;
    }

    return messages.inStock;
  }

  // 0 available, continue selling
  if (cargoReady) {
    if (backorderDate) {
      return messages.reserveNowDate;
    }

    return messages.reserveNow;
  }

  if (backorderDate) {
    return messages.notifyMeDate;
  }

  return messages.notifyMe;
}
